(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  const mobileToggle = $('[data-mobile-toggle]');
  const mobileNav = $('[data-mobile-nav]');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', () => {
      const open = mobileToggle.getAttribute('aria-expanded') === 'true';
      mobileToggle.setAttribute('aria-expanded', String(!open));
      mobileNav.hidden = open;
    });
  }

  const drawer = $('[data-cart-drawer]');
  const body = $('[data-cart-body]');
  const footer = $('[data-cart-footer]');
  const total = $('[data-cart-total]');
  const countEls = $$('[data-cart-count]');
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);

  const openCart = async () => {
    if (!drawer) return;
    await refreshCart();
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
  };
  const closeCart = () => {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  };
  $$('[data-cart-open]').forEach(el => el.addEventListener('click', openCart));
  $$('[data-cart-close]').forEach(el => el.addEventListener('click', closeCart));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  async function refreshCart() {
    if (!body) return;
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      countEls.forEach(el => el.textContent = cart.item_count);
      if (!cart.item_count) {
        body.innerHTML = '<p class="cart-empty">Dein Warenkorb ist noch leer.</p>';
        if (footer) footer.hidden = true;
        return;
      }
      body.innerHTML = cart.items.map(item => `
        <div class="cart-line">
          <div>${item.image ? `<img src="${item.image}" alt="" loading="lazy">` : ''}</div>
          <div><strong>${escapeHtml(item.product_title)}</strong><small>${escapeHtml(item.variant_title || '')}</small><div>${item.quantity} × ${money(item.final_price)}</div></div>
        </div>`).join('');
      if (total) total.textContent = money(cart.total_price);
      if (footer) footer.hidden = false;
    } catch (e) { console.error('Cart refresh failed', e); }
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  }

  $$('[data-product-form]').forEach(form => {
    const btn = $('[data-atc]', form);
    const txt = $('[data-atc-text]', form);
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (!btn) return;
      const original = txt ? txt.textContent : '';
      btn.disabled = true;
      if (txt) txt.textContent = 'Wird hinzugefügt…';
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) });
        if (!res.ok) throw new Error('Add to cart failed');
        if (txt) txt.textContent = 'Hinzugefügt ✓';
        setTimeout(() => { if (txt) txt.textContent = original; btn.disabled = false; }, 850);
        openCart();
      } catch (err) {
        if (txt) txt.textContent = 'Bitte erneut versuchen';
        btn.disabled = false;
      }
    });
  });

  const productSection = $('[data-product-section]');
  if (productSection) {
    const form = $('[data-product-form]', productSection);
    const sticky = $('[data-sticky-atc]', productSection);
    const stickySubmit = $('[data-sticky-submit]', productSection);
    if (form && sticky) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => sticky.classList.toggle('is-visible', !entry.isIntersecting));
      }, { threshold: 0.1 });
      observer.observe(form);
      if (stickySubmit) stickySubmit.addEventListener('click', () => form.requestSubmit());
    }
  }
})();

// NORLUNI V2 interactions
(() => {
  const section = document.querySelector('[data-product-section]');
  if (!section) return;
  const form = section.querySelector('[data-product-form]');
  if (form) {
    const input = form.querySelector('input[name="quantity"]');
    const minus = form.querySelector('[data-qty-minus]');
    const plus = form.querySelector('[data-qty-plus]');
    if (input && minus) minus.addEventListener('click', () => { input.value = Math.max(1, Number(input.value || 1) - 1); });
    if (input && plus) plus.addEventListener('click', () => { input.value = Math.max(1, Number(input.value || 1) + 1); });
  }

  const gallery = section.querySelector('[data-product-gallery]');
  const dots = [...section.querySelectorAll('.gallery-dots span')];
  const items = gallery ? [...gallery.querySelectorAll('[data-gallery-item]')] : [];
  if (gallery && dots.length && items.length) {
    let ticking = false;
    gallery.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const x = gallery.scrollLeft + gallery.clientWidth * .35;
        let active = 0;
        items.forEach((item, i) => { if (item.offsetLeft <= x) active = i; });
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
        ticking = false;
      });
    }, { passive: true });
  }
})();

// NORLUNI V3 variant pills, availability and price synchronization
(() => {
  const section = document.querySelector('[data-product-section]');
  if (!section) return;
  const json = section.querySelector('[data-product-json]');
  const select = section.querySelector('[data-variant-select]');
  const groups = [...section.querySelectorAll('[data-option-position]')];
  if (!json || !select || !groups.length) return;
  let variants = [];
  try { variants = JSON.parse(json.textContent); } catch (_) { return; }
  const formatMoney = cents => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency',currency:'EUR'}).format(cents/100);
  const selectedOptions = () => groups.map(group => {
    const active = group.querySelector('.variant-pill.is-selected');
    return active ? active.dataset.optionValue : null;
  });
  const sync = () => {
    const options = selectedOptions();
    const variant = variants.find(v => v.options.every((val, i) => val === options[i]));
    if (!variant) return;
    select.value = variant.id;
    select.dispatchEvent(new Event('change', {bubbles:true}));
    const current = section.querySelector('[data-current-price]');
    const compare = section.querySelector('[data-compare-price]');
    const saving = section.querySelector('[data-saving]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const atc = section.querySelector('[data-atc]');
    const atcText = section.querySelector('[data-atc-text]');
    if (current) current.textContent = formatMoney(variant.price);
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
    const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (compare) { compare.hidden = !onSale; if (onSale) compare.textContent = formatMoney(variant.compare_at_price); }
    if (saving) { saving.hidden = !onSale; if (onSale) saving.textContent = `Spare ${formatMoney(variant.compare_at_price - variant.price)}`; }
    if (atc) atc.disabled = !variant.available;
    if (atcText) atcText.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
    if (variant.featured_media && variant.featured_media.id) {
      const galleryWrap = section.querySelector('[data-hf35-gallery]');
      if (galleryWrap && typeof galleryWrap.hf35ShowMedia === 'function') galleryWrap.hf35ShowMedia(variant.featured_media.id);
    }
    const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
  };
  groups.forEach((group, groupIndex) => {
    group.querySelectorAll('[data-option-value]').forEach(btn => btn.addEventListener('click', () => {
      group.querySelectorAll('[data-option-value]').forEach(x => { x.classList.remove('is-selected'); x.setAttribute('aria-pressed','false'); });
      btn.classList.add('is-selected'); btn.setAttribute('aria-pressed','true');
      const label = group.querySelector('[data-selected-option]'); if (label) label.textContent = btn.dataset.optionValue;
      sync();
    }));
  });
})();

// NORLUNI V4 before/after comparison
(() => {
  const initBeforeAfter = (scope = document) => {
    scope.querySelectorAll('[data-before-after]').forEach((section) => {
      if (section.dataset.baInit === 'true') return;
      const range = section.querySelector('[data-ba-range]');
      const canvas = section.querySelector('.nl-ba');
      if (!range || !canvas) return;
      const update = () => canvas.style.setProperty('--position', `${range.value}%`);
      range.addEventListener('input', update, { passive: true });
      update();
      section.dataset.baInit = 'true';
    });
  };
  document.addEventListener('DOMContentLoaded', () => initBeforeAfter());
  document.addEventListener('shopify:section:load', (event) => initBeforeAfter(event.target));
})();

// NORLUNI announcement slider
(() => {
  const sliders = document.querySelectorAll('[data-announcement-slider]');
  sliders.forEach((slider) => {
    if (slider.dataset.initialized === 'true') return;
    slider.dataset.initialized = 'true';
    const slides = Array.from(slider.querySelectorAll('[data-announcement-slide]'));
    const prev = slider.querySelector('[data-announcement-prev]');
    const next = slider.querySelector('[data-announcement-next]');
    if (slides.length < 2) return;
    let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer = null;
    const interval = Math.max(3000, Number(slider.dataset.interval) || 5000);

    const show = (newIndex) => {
      index = (newIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
    };
    const stop = () => { if (timer) window.clearInterval(timer); timer = null; };
    const start = () => {
      stop();
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = window.setInterval(() => show(index + 1), interval);
      }
    };
    prev?.addEventListener('click', () => { show(index - 1); start(); });
    next?.addEventListener('click', () => { show(index + 1); start(); });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    start();
  });
})();

// NORLUNI V4.2 — keep fixed header offsets exact when Shopify/editor/content changes height
(() => {
  const syncFixedHeaderHeights = () => {
    const announcement = document.querySelector('.announcement--slider');
    const header = document.querySelector('.site-header');
    const root = document.documentElement;
    if (!header) return;

    const announcementHeight = announcement ? Math.ceil(announcement.getBoundingClientRect().height) : 0;
    const headerHeight = Math.ceil(header.getBoundingClientRect().height);
    root.style.setProperty('--nl-announcement-height', `${announcementHeight}px`);
    root.style.setProperty('--nl-header-height', `${headerHeight}px`);
  };

  const scheduleSync = () => window.requestAnimationFrame(syncFixedHeaderHeights);
  document.addEventListener('DOMContentLoaded', scheduleSync);
  window.addEventListener('load', scheduleSync, { once: true });
  window.addEventListener('resize', scheduleSync, { passive: true });
  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('shopify:section:unload', scheduleSync);
  document.addEventListener('shopify:section:reorder', scheduleSync);

  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(scheduleSync);
    const observe = () => {
      const announcement = document.querySelector('.announcement--slider');
      const header = document.querySelector('.site-header');
      if (announcement) observer.observe(announcement);
      if (header) observer.observe(header);
    };
    document.addEventListener('DOMContentLoaded', observe);
  }
})();

// HaarFrei V3.5 — single-image product gallery with thumbnails + mobile swipe
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-hf35-gallery]').forEach((wrap) => {
      if (wrap.dataset.hf35Init === 'true') return;
      const gallery = wrap.querySelector('[data-product-gallery]');
      const slides = [...wrap.querySelectorAll('[data-gallery-item]')];
      const thumbs = [...wrap.querySelectorAll('[data-gallery-thumb]')];
      const prev = wrap.querySelector('[data-gallery-prev]');
      const next = wrap.querySelector('[data-gallery-next]');
      const current = wrap.querySelector('[data-gallery-current]');
      if (!gallery || !slides.length) return;
      wrap.dataset.hf35Init = 'true';
      let index = Math.max(0, slides.findIndex(s => s.classList.contains('is-active')));

      const show = (newIndex, scrollThumb = true) => {
        index = (newIndex + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.hidden = !active;
        });
        thumbs.forEach((thumb, i) => {
          const active = i === index;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (current) current.textContent = String(index + 1);
        if (scrollThumb && thumbs[index]) thumbs[index].scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
      };

      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i, false)));
      prev?.addEventListener('click', () => show(index - 1));
      next?.addEventListener('click', () => show(index + 1));

      let startX = null;
      gallery.addEventListener('touchstart', e => { startX = e.touches[0]?.clientX ?? null; }, {passive:true});
      gallery.addEventListener('touchend', e => {
        if (startX === null) return;
        const endX = e.changedTouches[0]?.clientX ?? startX;
        const delta = endX - startX;
        startX = null;
        if (Math.abs(delta) < 45) return;
        show(delta < 0 ? index + 1 : index - 1);
      }, {passive:true});

      wrap.hf35ShowMedia = (mediaId) => {
        const target = slides.findIndex(s => String(s.dataset.mediaId) === String(mediaId));
        if (target >= 0) show(target);
      };
      show(index, false);
    });
  };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', e => init(e.target));
  init();
})();
